import React from 'react';
import moment from 'moment';
import { ifElse } from 'ramda';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { compose, withHandlers, withProps } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';
import withToggle from '../../../../common/hoc/withToggle';
import SimpleCheckbox from '../../../../common/simpleCheckbox';
import { generateTimes } from '../../../../common/helpers/schedules';

const renderEnabledCheckbox = (field) => {
  const dayName = moment().isoWeekday(field.input.value).format('dddd');
  return (
    <div className="o-flexbox__item">
      <SimpleCheckbox key={field} label={dayName} id={field.enabledName} name={field.enabledName} />
    </div>
  );
};

const renderScheduleItem = (times) => (item) => {
  return (
    <div className="o-flexbox u-mb-" key={item}>
      <Field name={`${item}.weekDay`} enabledName={`${item}.enabled`} component={renderEnabledCheckbox} />
      <div className="o-flexbox__item">
        <Field name={`${item}.startTime`} component="select" className="c-select c-select--small u-mr--">
          {times}
        </Field>
        <Field name={`${item}.finishTime`} component="select" className="c-select c-select--small">
          {times}
        </Field>
      </div>
    </div>
  );
};

const renderScheduleItems = ({ fields, times }) => <div>{fields.map(renderScheduleItem(times))}</div>;

const PromoSchedule = (props) => {
  const { isScheduled, times } = props;
  return (
    <div>
      <SimpleCheckbox label={t('settings:promo_codes.schedule.limit_days_times')} id="isScheduled" name="isScheduled" />
      <div display-if={isScheduled} className="u-mt">
        <FieldArray name="schedule" component={renderScheduleItems} times={times} />
      </div>
    </div>
  );
};

PromoSchedule.propTypes = {
  isScheduled: PropTypes.bool.isRequired,
  times: PropTypes.arrayOf(PropTypes.element).isRequired,
};

const rangeConfig = {
  start: {
    hours: '8',
    minutes: '0',
  },
  end: {
    hours: '22',
    minutes: '0',
  },
};

export default compose(
  withToggle('expanded', false),
  withHandlers({
    toggleExpanded: (props) => ifElse(() => props.expandedIsOn, props.expandedOff, props.expandedOn),
  }),
  withProps(() => ({
    times: generateTimes(false, 15, rangeConfig).map((time) => (
      <option value={time} key={time}>
        {time}
      </option>
    )),
  }))
)(PromoSchedule);
